import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "working" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) return setState({ status: "error", message: "Missing unsubscribe token." });
    api.get("/unsubscribe", { params: { token, scope: params.get("scope") || "all" } })
      .then((r) => setState({ status: "done", email: r.data.email, scope: r.data.scope }))
      .catch((e) => setState({ status: "error", message: formatApiErrorDetail(e.response?.data?.detail) }));
  }, [params]);

  return (
    <div className="min-h-screen bg-paper-light flex flex-col">
      <Header />
      <main className="flex-1 max-w-xl mx-auto px-6 py-20 text-center" data-testid="unsubscribe-page">
        <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-gold">Email preferences</p>
        {state.status === "working" && <h1 className="mt-2 text-2xl font-bold text-ink">Updating your preferences…</h1>}
        {state.status === "done" && (
          <>
            <h1 className="mt-2 text-2xl font-bold text-ink" data-testid="unsubscribe-done">{state.scope === "digest" ? "Weekly digest stopped" : "You're unsubscribed"}</h1>
            <p className="mt-3 text-[14px] text-ink-muted">{state.scope === "digest" ? `${state.email} will no longer get the weekly saved-events digest. Your daily 7am and birthday emails continue.` : `${state.email} will no longer receive daily horoscopes or birthday emails from OddlyTrue.`}</p>
          </>
        )}
        {state.status === "error" && (
          <>
            <h1 className="mt-2 text-2xl font-bold text-ink" data-testid="unsubscribe-error">That link didn't work</h1>
            <p className="mt-3 text-[14px] text-ink-muted">{state.message}</p>
          </>
        )}
        <Link to="/" className="inline-block mt-8 text-[13px] font-semibold text-gold hover:underline">Back to On This Day →</Link>
      </main>
      <Footer />
    </div>
  );
}
